export default "__VITE_ASSET__DrGcobFw__"